import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';

import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/guard/auth.guard';

import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

import { SharedComponentModule } from './views/shared-component/shared-component.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ThaiDatePipe } from './core/pipe/thai-date.pipe';
import { AuthService } from './services/auth.service';
import { Interceptor } from './services/interceptor.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ManageEquipmentComponent } from './views/pages/manage-equipment/manage-equipment.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxCurrencyModule } from 'ngx-currency';
import { RequestEquipmentComponent } from './views/pages/request-equipment/request-equipment.component';
import { MasterEquipmentComponent } from './views/pages/master-equipment/master-equipment.component';

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve: any) => {
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ".",
  precision: 0,
  prefix: "",
  suffix: "",
  thousands: ",",
  nullable: true
};

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    RequestEquipmentComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    SharedComponentModule,
    HttpClientModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig)
  ],
  exports: [
    
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
    AuthGuard,
    //{
    //  provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
    //  useValue: {
    //    coreLibraryLoader: () => import('highlight.js/lib/core'),
    //    languages: {
    //      xml: () => import('highlight.js/lib/languages/xml'),
    //      typescript: () => import('highlight.js/lib/languages/typescript'),
    //      scss: () => import('highlight.js/lib/languages/scss'),
    //    }
    //  }
    //},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
